module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "card-list",
    attrs: {
      "xs12": "",
      "md8": "",
      "offset-md2": "",
      "pb-5": "",
      "mt-3": ""
    }
  }, [_c('v-stepper', {
    ref: "stepper",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.currStep),
      callback: function($$v) {
        _vm.currStep = $$v
      },
      expression: "currStep"
    }
  }, [_vm._l((_vm.bio), function(item, n) {
    return [_c('v-stepper-step', {
      ref: "steps",
      refInFor: true,
      attrs: {
        "step": n + 1,
        "complete": _vm.currStep > n,
        "editable": ""
      }
    }, [_vm._v("\n\n                " + _vm._s(((item.name) + ": " + (item.location))) + "\n\n                "), _c('small', [_vm._v(_vm._s(("" + (item.date))))])]), _vm._v(" "), _c('v-stepper-content', {
      key: n,
      attrs: {
        "step": n + 1
      }
    }, [_c('v-card', {
      class: [((_vm.settingsObj.themeColor) + " lighten-2"), 'white--text', 'mb-3', 'elevation-3']
    }, [_c('v-card-text', {
      staticClass: "description-text"
    }, [_c('ul', _vm._l((item.descriptionArr), function(descItem, i2) {
      return _c('li', {
        key: descItem,
        attrs: {
          "light": ""
        }
      }, [_vm._v("\n                                " + _vm._s(descItem) + "\n                            ")])
    }))])], 1), _vm._v(" "), _c('v-btn', {
      class: [((_vm.settingsObj.themeColor) + " darken-2"), 'white--text'],
      on: {
        "click": function($event) {
          _vm.currStep = n + 2
        }
      }
    }, [_vm._v("Continue\n                ")])], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-634d2da7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepList.vue
// module id = 466
// module chunks = 0